export default __webpack_public_path__ + "static/book-thumb-5ca022a478bc344451f34c9cfad44723.png";